import{h as T}from"./handleize-BgPkOmuO.js";import{c as $}from"./currency.cjs-D9VPANVS.js";window.themeVariables=window.themeVariables||{};window.themeVariables.nosto=window.themeVariables.nosto||{};var v;const G=((v=window.themeVariables)==null?void 0:v.settings)||{};var V;const Y=((V=window.themeVariables)==null?void 0:V.strings)||{};var O;const g=((O=window.themeVariables)==null?void 0:O.nosto)||{};var x;const W=((x=window.themeVariables)==null?void 0:x.icons)||{};var j;const Z=((j=window.themeVariables)==null?void 0:j.productCard)||{};var q;const X=((q=window.themeVariables)==null?void 0:q.cart)||{};var C;const R=((C=window.themeVariables)==null?void 0:C.customer)||null;var U;const ee=((U=window.themeVariables)==null?void 0:U.product)||null;var F;const re=((F=window.themeVariables)==null?void 0:F.collection)||null;var D;const te=((D=window.themeVariables)==null?void 0:D.search)||null,E="global-",oe=g.popularitySortDefaultRuleId?`${E}${g.popularitySortDefaultRuleId}`:null,ie=g.customSortRuleId?`${E}${g.customSortRuleId}`:null,se={settings:G,strings:Y,nosto:g,icons:W,productCard:Z,cart:X,customer:R,product:ee,collection:re,search:te,defaultPopularitySortID:oe,customPopularitySortID:ie};function ze(r,e=!1){return r?e?ae(r):ne(r):null}function ae(r){if(!r)return null;const e=le(r.skus||[]),t=H(e),o=de(e);return{id:r.product_id||r.id,productId:r.product_id||r.id,pid:r.product_id||r.id,name:r.name||"Product",url:r.url||"",...B(r.price,r.list_price),...L(r.image_url,r.alternate_image_urls,r.thumb_url),...o,variants:e,skus:e,tags:r.tags||[],tags1:r.tags1||[],tags2:r.tags2||[],tags3:r.tags3||[],customFields:K(r.custom_fields),attributes:r.attributes||[],affinities:t,brand:r.brand,categories:r.categories||[],description:r.description,date_published:r.date_published,price_currency_code:r.price_currency_code,price_text:r.price_text,list_price_text:r.list_price_text,variant_id:r.variant_id,handle:ce(r.url,r.name)}}function ne(r){var s,a;if(!r)return null;const e={...r},t=ue(e.skus||[]);e.id=e.pid||e.productId||null,e.name=e.name||e.title||"Product",Object.assign(e,B(e.price,e.listPrice)),Object.assign(e,L(e.imageUrl,e.alternateImageUrls)),Object.assign(e,A(e.available,e.availability)),e.customFields=e.customFields||e.attributes||[],e.tags=e.tags1||[],e.variants=t,e.skus=t,e.handle=T(e.name);const o=((s=e.url)==null?void 0:s.split("/"))||[];e.urlHandle=o.pop()||e.handle;const i=e.customFields.find(n=>{var c;return((c=n==null?void 0:n.key)==null?void 0:c.toLowerCase())==="producttype"});return e.type=(i==null?void 0:i.value)||null,e.secondaryImage=((a=e.alternateImageUrls)==null?void 0:a.length)>0?e.alternateImageUrls[0]:null,e.affinities||(e.affinities=H(e.variants)),e}function B(r,e){return{price:parseFloat(r)||0,listPrice:parseFloat(e)||0}}function L(r,e,t=null){return{imageUrl:r||"",alternateImageUrls:e||[],...t&&{thumb_url:t}}}function A(r,e){const t=typeof r=="boolean"?r:e==="InStock";return{available:t===!0,availability:e||(t?"InStock":"OutOfStock")}}function ce(r,e){return r?r.split("/").pop():T(e||"product")}function le(r){return Array.isArray(r)?r.map(e=>{if(!e||typeof e!="object")return null;const t=K(e.custom_fields),{size:o,color:i}=J(t),s=A(e.available,e.availability);return{...e,customFields:t,size:o,color:i,...s}}).filter(Boolean):[]}function ue(r){return Array.isArray(r)?r.map(e=>{if(!e||typeof e!="object")return null;e.customFields=e.customFields||e.attributes||[];const{size:t,color:o}=J(e.customFields),i=A(e.available,e.availability);return{...e,size:t,color:o,...i}}).filter(Boolean):[]}function J(r){if(!Array.isArray(r))return{size:null,color:null};const e=r.find(o=>{var i;return((i=o==null?void 0:o.key)==null?void 0:i.toLowerCase())==="size"}),t=r.find(o=>{var i;return((i=o==null?void 0:o.key)==null?void 0:i.toLowerCase())==="color"});return{size:(e==null?void 0:e.value)||null,color:(t==null?void 0:t.value)||null}}function H(r){const e={};if(!Array.isArray(r)||r.length===0)return e;const t=[...new Set(r.map(i=>i.size).filter(Boolean))],o=[...new Set(r.map(i=>i.color).filter(Boolean))];return t.length>0&&(e.size=t),o.length>0&&(e.color=o),e}function de(r){if(!Array.isArray(r)||r.length===0)return{available:!1,availability:"OutOfStock"};const e=r.some(t=>t.available===!0);return{available:e,availability:e?"InStock":"OutOfStock"}}function K(r){return!r||typeof r!="object"||Array.isArray(r)?[]:Object.entries(r).map(([e,t])=>({key:e,value:(t==null?void 0:t.toString())||""})).filter(e=>e.key&&e.value)}function ke(r){return Array.isArray(r)?r.map(e=>{var t;return!e||typeof e!="object"?null:{keyword:e.keyword||"",redirect:e._redirect||null,highlight:((t=e._highlight)==null?void 0:t.keyword)||e.keyword||""}}).filter(Boolean):[]}function $e(r){if(!Array.isArray(r))return{pages:[],collections:[],keywords:[]};const e=[],t=[],o=[];for(const i of r)i.redirect&&i.redirect.includes("/pages/")?e.push({title:i.keyword,url:i.redirect,highlight:i.highlight}):i.redirect&&i.redirect.includes("/collections/")?t.push({title:i.keyword,url:i.redirect,highlight:i.highlight}):o.push(i);return{pages:e,collections:t,keywords:o}}const{nosto:u,defaultPopularitySortID:_,customPopularitySortID:N}=se,me=u.searchSizeRecs||5,w=new Map;function fe(r,e,t,o,i,s,a){return JSON.stringify({collectionId:r||null,activeFilters:e||[],currentItemCount:o,gridOffset:i,context:s,searchTerm:a||"",pageNumber:t==null?void 0:t.pageNumber,from:t==null?void 0:t.from,productsPerPage:t==null?void 0:t.productsPerPage,sort:t==null?void 0:t.sort})}const pe=u.autocompleteProductsSize||5,ye=u.keywordsSize||5;async function I(r,e,t){const o="https://search.nosto.com/v1/graphql",i={method:"POST",signal:t,headers:{"Content-Type":"application/json"},body:JSON.stringify({query:r,variables:e})};try{const s=await fetch(o,i);if(!s.ok){const a=await s.text();return console.error("Nosto search error:",{status:s.status,statusText:s.statusText,responseBody:a}),null}return await s.json()}catch(s){return console.error("Error fetching from Nosto API:",s),null}}async function he(r){const e="https://api.nosto.com/v1/graphql",t={method:"POST",headers:{"Content-Type":"application/json",Authorization:"Basic "+btoa(`:${u.authToken}`)},mode:"cors",body:JSON.stringify({query:r})};try{const o=await fetch(e,t);if(!o.ok){const i=await o.text();return console.error("Nosto recommendations error:",{status:o.status,statusText:o.statusText,responseBody:i}),null}return await o.json()}catch(o){return console.error("Error fetching from Nosto Recommendations API:",o),null}}async function _e(r,e,t,o,i,s="collection",a,n){const c=fe(r,e,t,o,i,s,a),d=w.get(c);if(d)return d;const l=ge(r,e,t,o,i,s,a,n);return w.set(c,l),l.finally(()=>w.delete(c)),l}async function ge(r,e,t,o,i,s="collection",a,n){var b,z,k;const{productsPerPage:c,from:d}=t;let l,p;t.pageNumber>1&&o===0?(l=(t.pageNumber-1)*c,p=c):t.pageNumber>1&&o>0?(l=o,p=c):(l=d,p=c);const m={segments:u.abTestSegments||[],products:{size:p,from:l}};(b=t.sort)!=null&&b.field&&((z=t.sort)!=null&&z.order)&&t.sort.field!=="popularity"&&(m.products.sort=t.sort),s==="collection"&&(m.products.categoryId=r);const S=s==="search"&&a?`query: "${a}",`:"";e!=null&&e.length&&(m.products.filter=e);let y="";if(N&&((k=t.sort)==null?void 0:k.field)==="popularity"){let f=`{id: "${N}", enabled: true}`;_&&(f+=`,{id: "${_}", enabled: false}`),y=`customRules: [${f}],`}const h=`
    query (
      $segments: [String!],
      $products: InputSearchProducts,
      $abTests: [InputSearchABTest!]
    ) {
      search(
        accountId: "${u.siteId}",
        ${S}
        ${y}
        segments: $segments
        products: $products,
        keywords: {
          size: ${ye}
        }
        abTests: $abTests
      ) {
        redirect
        products {
          total
          from
          size
          hits {
            pid
            productId
            name
            url
            price
            listPrice
            imageUrl
            alternateImageUrls
            available
            tags1
            skus {
              id
              name
              availability
              price
              imageUrl
              customFields {
                key
                value
              }
            }
            affinities {
              color
              size
            }
            customFields {
              key
              value
            }
          }
          fuzzy
          facets {
            ... on SearchStatsFacet {
              name
              field
              min
              max
              id
            }
            ... on SearchTermsFacet {
              name
              field
              data {
                value
                count
                selected
              }
              id
            }
          }
        }
        keywords {
          hits {
            keyword
            _redirect
            _highlight {
              keyword
            }
          }
        }
        abTests {
          id
          name
          activeVariation {
            id
          }
          allVariations {
            id
          }
        }
      }
    }
  `;try{return await I(h,m,n)}catch(f){throw console.error("Nosto search error:",f),f}}async function Ne(r){const e={products:{size:pe,from:0}},t=`
    query (
      $products: InputSearchProducts
    ) {
      search(
        accountId: "${u.siteId}",
        query: "${r}",
        products: $products,
        keywords: {
          size: 20
        },
        categories: {
          size: 10
        }
      ) {
        products {
          total
          from
          size
          hits {
            pid
            productId
            name
            url
            price
            listPrice
            imageUrl
            alternateImageUrls
            available
            tags1
            skus {
              id
              name
              availability
              price
              imageUrl
              customFields {
                key
                value
              }
            }
            affinities {
              color
              size
            }
            customFields {
              key
              value
            }
          }
          facets {
            ... on SearchTermsFacet {
              name
              field
              data {
                value
                selected
              }
              id
            }
          }
          fuzzy
        }
        keywords {
          hits {
            keyword
            _redirect
            _highlight {
              keyword
            }
          }
        }
        categories {
          hits {
            name
            url
          }
          total
        }
      }
    }
  `;try{return await I(t,e)}catch(o){return console.error("Nosto autocomplete search error:",o),null}}async function ve(r=5){var t,o,i;const e=`
    {
      search(
        accountId: "${u.siteId}"
        query: ""
        popularSearches: {size: ${r}, emptyQueryMatchesAll: true}
      ) {
        popularSearches {
          hits {
            query
            total
          }
          total
        }
        query
      }
    }
  `;try{const s=await I(e,{});return((i=(o=(t=s==null?void 0:s.data)==null?void 0:t.search)==null?void 0:o.popularSearches)==null?void 0:i.hits)||[]}catch(s){return console.error("Nosto popular searches error:",s),null}}const be=r=>r?`exclude: {
      productIds: '${r}'
    },`:"",we=r=>r?`include: {
      productIds: '${r}'
    },`:"",Pe=r=>{const e=r.excludeProducts&&r.excludeProducts.length?be(JSON.stringify(r.excludeProducts)):"",t=r.includeProducts&&r.includeProducts.length?we(JSON.stringify(r.includeProducts)):"";return`toplist(
    hours: ${r.toplistHours},
    sort: ${r.toplistScoringMode},
    params: {
      maxProducts: ${r.searchSize||me},
      ${e}
      ${t}
    }
  )`};async function Ve(r){let e;e=Pe(r);const t=`{
    recos(
      preview: false,
      image: VERSION_SOURCE
    ) {
      ${e} {
        primary {
          productId
          name
          url
          price
          listPrice
          imageUrl
          alternateImageUrls
          availability
          tags1
          skus {
            id
            name
            availability
            price
            imageUrl
            attributes {
              key
              value
            }
          }
          attributes {
            key
            value
          }
        }
      }
    }
  }`;try{return await he(t)}catch(o){return console.error("Nosto recommendations error:",o),null}}function Oe(r,e,t){if(!r||!e||!t){console.warn("Missing required product data for Nosto tracking");return}window.nostojs(o=>{o.recordSearchClick(r,{productId:e,url:t})})}function xe(r,e,t){if(Object.keys(e).length===0)return;const o={query:e.term,products:{sort:e.sort,filter:e.filter}},i={products:{hits:Array.isArray(t)?t.map(a=>({productId:a.productId})):[],fuzzy:e.fuzzy,size:e.size,from:e.from,total:e.total},properties:{}},{abTests:s}=e;if(s!=null&&s.length){const a=Object.fromEntries(s.filter(n=>{var c;return n.id&&((c=n.activeVariation)==null?void 0:c.id)}).map(n=>[n.id,n.activeVariation.id]));Object.keys(a).length&&(i.properties.abTestAttribution=a,i.abTests=s)}r==="category"&&(i.products.categoryPath=e.term),window.nostojs(a=>{a.recordSearch(r,o,i)})}function je(r,e){if(!r){console.warn("Missing product ID for Nosto recommended product tracking");return}window.nostojs(t=>{t.recommendedProductAddedToCart(r,e||"")})}const Q=()=>{var e;const r=document.querySelector("cart-drawer .nosto_element");r&&((e=window.Nosto)==null||e.reloadCart([r.id]),setTimeout(()=>{r.style.opacity="1"},2e3))};document.addEventListener("cart-drawer:refreshed",()=>{Q()});document.addEventListener("DOMContentLoaded",()=>{Q()});var M;const P=((M=window.themeVariables)==null?void 0:M.settings)||{},Ae=(r,e=!0)=>{const t=window.Shopify.currency.active,o=P.shopCurrency,i=e?P.moneyFormat:P.moneyWithoutCurrencyFormat;if(o===t)return $.formatMoney(r*100,i);let s=r*100*window.Shopify.currency.rate,a=!1,n=0,c=0,d=.1,l=.05;switch(t){case"USD":case"HKD":case"SAR":case"AED":l=0;break;case"NZD":l=.1,n=.15;break;case"JPY":a=!0;break;case"SGD":l=.05,n=.09;break;case"CAD":l=.05,c=.03;break;default:l=.05}c!==0&&(s=s*(1+c)),o==="AUD"&&n!==0&&(s=s/(1+d)*(1+n));const m=Math.floor(s)/100;let y=(Math.ceil(m)-l)*100;if(a){const h=Math.trunc(s),b=h.toString().slice(-3);y=parseInt(b)>=50?Math.ceil(h/1e4)*1e4:Math.floor(h/1e4)*1e4}return $.formatMoney(y,i)};window.theme.localPrice=window.localPrice||Ae;export{Oe as a,xe as b,se as c,Ve as d,Ne as e,ke as f,_e as g,ve as h,Ae as l,je as n,$e as s,ze as t};
